import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';

type PortfolioVisibilityIndicatorProps = {
  visible?: boolean;
  locked?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioVisibilityIndicator',
  props: {
    visible: { type: Boolean, default: false },
    locked: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { visible: boolean, locked: boolean };



const label = computed(() => (props.locked ? 'Private' : props.visible ? 'Public' : 'Private'));
const icon = computed(() => (props.locked ? 'lock' : props.visible ? 'eye' : 'eye-crossed'));

return { __sfc: true,props, label, icon }
}

})